export default __webpack_public_path__ + "static/media/xml-_1_.719ecdba.svg";